import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
    alert(t.contact.successMessage);
    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
      <>
        <div style={{ clear: 'both' }} />
        <div className="contact-section" id="section-7">
          <div className="contact-wrap row">
            <div className="contact-title">
              <h4>{t.contact.title}</h4>
              <p>{t.contact.subtitle}</p>
            </div>

            <div className="contact-content">
              <div className="contact-form-wrapper">
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder={t.contact.form.name}
                        required
                    />
                  </div>
                  <div className="form-group">
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder={t.contact.form.email}
                        required
                    />
                  </div>
                  <div className="form-group">
                  <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder={t.contact.form.message}
                      rows="6"
                      required
                  />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    {t.contact.form.send}
                  </button>
                </form>
              </div>

              <div className="contact-info">
                <div className="info-item">
                  <i className="fa fa-map-marker" />
                  <div className="info-text">
                    <h6>{t.contact.address}</h6>
                    <p>{t.contact.addressValue}</p>
                  </div>
                </div>
                <div className="info-item">
                  <i className="fa fa-envelope" />
                  <div className="info-text">
                    <h6>{t.contact.emailLabel}</h6>
                    <p>{t.contact.emailValue}</p>
                  </div>
                </div>
                <div className="info-item">
                  <i className="fa fa-globe" />
                  <div className="info-text">
                    <h6>{t.contact.website}</h6>
                    <p>{t.contact.websiteValue}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
};

export default Contact;
